exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles--notAuthenticated--hhjNDgMQ {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  color: gray;\r\n}\r\n\r\n.styles--notAuthenticated--hhjNDgMQ i {\r\n  font-size: 30rem;\r\n}\r\n\r\n.styles--notAuthenticated--hhjNDgMQ h1 {\r\n  font-size: 3rem;\r\n  font-weight: bolder;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.styles--notAuthenticated--hhjNDgMQ p {\r\n  font-size: 1.2rem;\r\n}", ""]);

// exports
exports.locals = {
	"notAuthenticated": "styles--notAuthenticated--hhjNDgMQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/views/NotAuthenticated/styles.css
// module id = 882
// module chunks = 1